// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSwitch-Container_cls1__kjHD1","cls2":"VeloSwitch-Container_cls2__ZtpO5 VeloSwitch-Container_cls1__kjHD1"};